import { ProgramRelease } from "./programrelease.model";

export interface IProgram {
    id: number;
    programDescription?: string;
    programName?: string;
    shortName?: string;
    visible?: boolean;
    releases?: Array<string>;
    fullReleases?: Array<ProgramRelease>;
}

export class Program implements IProgram {
    constructor(
        public id: number,
        public programDescription?: string,
        public programName?: string,
        public shortName?: string,
        public visible?: boolean,
        public releases?: string[],
        public fullReleases?: Array<ProgramRelease>
    ) { }
}
